import { useEffect, useState } from "react"

export function useAdmin() {
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    const admin = localStorage.getItem("isAdmin")
    setIsAdmin(admin === "true")
  }, [])

  return isAdmin
}